var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclineicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33854 11.8334L0.171875 10.6667L4.83854 6.00008L0.171875 1.33341L1.33854 0.166748L6.00521 4.83341L10.6719 0.166748L11.8385 1.33341L7.17187 6.00008L11.8385 10.6667L10.6719 11.8334L6.00521 7.16675L1.33854 11.8334Z",
    fill: "#DB545D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineicon);
export default __webpack_public_path__ + "static/media/declineicon.d29e752a9290c5e86b0e219594ba35f3.svg";
export { ForwardRef as ReactComponent };